<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.form-hero {
    position: relative;
    z-index: auto;
    margin-bottom: 16px;

    @media screen and (min-width: $screen-md) {
        margin-bottom: 56px;
    }

    @media screen and (min-width: $screen-xl) {
        margin-bottom: 96px;
    }

    .hero {
        background-color: $primary;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        padding: 120px 0 64px 0;
        position: relative;

        @media screen and (min-width: $screen-lg) {
            padding: 192px 0 24px 0;
        }

        @media screen and (min-width: $screen-xl) {
            padding: 192px 0 200px 0;
        }

        &:before {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            content: "";
            background-color: rgba(43, 74, 132, 0.7);
        }

        .content {
            position: relative;
            z-index: 20;
        }

        .subtitle {
            font-weight: $font-weight-bold;
            letter-spacing: 0.29px;
            text-transform: uppercase;
        }

        .form {
            box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.03);
        }
    }

    &:after {
        content: "";
        background-image: url("/svg/shapes/header-1.svg");
        height: 80px;
        width: 100%;
        position: absolute;
        z-index: 2;
        right: 0;
        bottom: 0;

        @media screen and (min-width: $screen-sm) {
            background-size: cover;
            background-repeat: no-repeat;
        }
    }

    .flex-basis-auto {
        flex-basis: auto !important;
    }
}

.landing.with-menu {
    .form-hero {
        .hero {
            padding: 80px 0 24px 0;

            @media screen and (min-width: $screen-lg) {
                padding: 100px 0 24px 0;
            }

            @media screen and (min-width: $screen-xl) {
                padding: 256px 0 200px 0;
            }
        }
    }
}
</style>

<template>
    <div class="form-hero">
        <div class="hero" :style="possibleBackgroundImage">
            <div class="container content">
                <div class="row">
                    <div class="col-12 col-xl-6 mb-40 mb-xl-0" :class="description && (showForm == 'false') ? 'col-xl-12 d-flex flex-column flex-lg-row' : 'col-xl-6 '">
                        <div :class="description && (showForm == 'false') ? 'row' : ''">
                            <div :class="description && (showForm == 'false') ? 'col-12 col-lg-6' : ''">
                                <span v-if="subtitle" class="subtitle small text-white d-lg-inline-block mb-lg-16">{{ subtitle }}</span>
                                <h1 class="text-white" v-html="title"></h1>
                            </div>
                            <div :class="description && (showForm == 'false') ? 'col-12 col-lg-6 ' : ''">
                                <div class="text-white font-weight-light text-cut ml-lg-80 mb-child-0">
                                    <p v-if="description && (showForm == 'false')" v-html="description"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="showForm == 'true'" class="col-12 col-md-8 offset-md-4 col-lg-6 offset-lg-6 col-xl-5 offset-xl-1 position-relative">
                        <div class="position-relative">
                            <div id="hero-form" class="form mt-xl-n80 p-24 p-md-48 bg-white position-xl-absolute w-100" :class="{'processing': processing}">
                                <h2 class="text-black h5 mb-24">{{ formTitle }}</h2>

                                <ValidationObserver v-slot="obs" ref="observer" tag="form" @submit.prevent="submit()">
                                    <div class="form-row">
                                        <div class="col-12">
                                            <ValidationProvider ref="name" vid="name" rules="required|min:2" v-slot="props" :name="'Mijn Naam'" :slim="true">
                                                <div class="form-group position-relative" :class="props.classes">
                                                    <label for="form_hero_name">{{ translations.my_name }}</label>
                                                    <input type="text" id="form_hero_name" class="form-control" :placeholder="'Mijn Naam'" v-model="formData.name" />
                                                    <span class="error">{{ props.errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12">
                                            <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="'Mijn E-mailadres'" :slim="true">
                                                <div class="form-group position-relative" :class="props.classes">
                                                    <label for="form_hero_email">{{ translations.my_email }}</label>
                                                    <input type="text" id="form_hero_email" class="form-control" :placeholder="'Mijn E-mailadres'" v-model="formData.email" />
                                                    <span class="error">{{ props.errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12">
                                            <ValidationProvider ref="phone" vid="phone" :rules="{ required: true, regex:/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/}" v-slot="props" :name="'Mijn telefoonnnummer'" :slim="true">
                                                <div class="form-group position-relative" :class="props.classes">
                                                    <label for="form_hero_phone">{{ translations.my_phone }}</label>
                                                    <input type="text" id="form_hero_phone" class="form-control" :placeholder="'Mijn telefoonnnummer'" v-model="formData.phone" />
                                                    <span class="error">{{ props.errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12">
                                            <ValidationProvider ref="privacy-policy" vid="privacy-policy" :rules="{ required: { allowFalse: false } }" v-slot="props" :name="translations.privacy_agreement.replace(/%s/g, '').replace(/\.$/, '')" :slim="true">
                                                <div class="form-group position-relative" :class="props.classes">
                                                    <input type="checkbox" id="form_hero_privacy-policy" v-model="formData.privacyPolicy" />
                                                    <label class="checkbox" :class="{'checked': formData.privacyPolicy}" for="form_hero_privacy-policy" v-html="privacyPolicyLinkText"></label>
                                                    <span class="error error-top">{{ props.errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <span v-if="serverError" class="error error-large mb-20 d-block">{{ serverError }}</span>

                                    <button :disabled="obs.invalid" class="btn btn-secondary btn-lg">{{ formButton }}</button>
                                </ValidationObserver>

                                <div class="spinner-background">
                                    <div class="spinner">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
        },
        image: {
            type: String,
            required: false,
        },
        showForm: {
            type: String,
            required: false,
            default: false
        },
        translations: {
            type: Object,
            required: false
        },
        formTitle: {
            type: String,
            required: false,
        },
        formButton: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            processing: false, //when posting the formData
            submitted: false, //when formData is successfully submitted
            serverError: null, //stores a server error (with optional message)

            formData: {
                name: "",
                email: "",
                phone: "",
                privacyPolicy: null,
                page: window.location.href
            }
        }
    },

    computed: {
        possibleBackgroundImage() {
            if (this.image) return `background-image: url('${this.image}')`;
            return '';
        },

        privacyPolicyLinkText: function () {
            var output = this.translations.privacy_agreement;

            if ((output.match(/%s/g) || []).length == 2) { //only replace if 2 %s tags are present in the string
                var i = 0;
                var anchorReplacements = ["<a href=\"" + this.privacyPolicyLink + "\">", "</a>"]
                output = output.replace(/%s/g, function (matched) {
                    return anchorReplacements[i];
                    i++;
                });
            }

            return output;
        }
    },

    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.processing = true;
                //prepare FormData object from our generic object
                var formData = new FormData();
                formData.append('name', this.formData.name);
                formData.append('email', this.formData.email);
                formData.append('phone', this.formData.phone);
                formData.append('page', this.formData.page);

                axios
                    .post('/landing', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) this.done = true;

                        document.getElementById("hero-form").innerHTML = "";
                        var h5 = document.createElement('h5');
                        h5.innerHTML = this.translations.success_message;
                        document.getElementById('hero-form').appendChild(h5);

                        this.formData.name = "";
                        this.formData.email = "";
                        this.formData.phone = "";
                    })
                    .catch((error) => {
                        if (error.response.data.message == undefined) {
                            this.serverError = error.response.data;
                        } else {
                            this.serverError = error.response.data.message;
                        }
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        }
    }
}
</script>
